/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
  Tooltip,
  InputNumber,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { CheckCircleOutlined } from '@ant-design/icons';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { getAreas, getEstadosGlobales } from 'api/catalogos/index';
import { integerRegExp } from 'utils/patterns';
import ModalConfirmation from 'components/ModalConfirmation';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import {
  getJornadasDetalle,
  postJornadaDetalle,
  deleteJornadaDetalle,
  patchJornadaDetalle,
  getJornadaDetalle,
  autorizarJornadaDetalle,
} from 'api/catalogos/JornadaDetalle';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { getModelPermission } from 'utils/permission';
import { getPuestos } from 'api/estructuraOrganizacional/puestos';
import moment from 'moment/moment';
import JornadaDetalleHorario from './JornadaDetalleHorario';

export const jornadadetallePermission = {
  permissionModel: 'jornadadetalle',
  hasAllViewPermissions: true,
};

const JornadaDetalle = ({
  jornada, permission, showParentForm,
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open2, setVisible2] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [, setConfirmationVisibleEstatus] = useState(false);
  const [estados, setEstados] = useState([]);
  const [tiposempleados, setTiposEmpleados] = useState([]);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [areas, setAreas] = useState([]);
  const [puesto, setPuesto] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [selectedData] = useState({});

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getJornadasDetalle({ jornada });
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
        _tiposempleados,
        _areas,
        _puesto,
      ] = await Promise.all([
        getEstadosGlobales(),
        getJornadasDetalle({ jornada }),
        getTiposDeEmpleados(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPuestos(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setTiposEmpleados(_tiposempleados);
        setLoading(false);
        setAreas(_areas);
        setPuesto(_puesto);
      }
    };
    if (jornada) {
      fetchAll();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [jornada]);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setSelectedRowKeys([]);
    setVisible2(false);
    showParentForm();
    form.resetFields();
    formDatos.resetFields();
  };
  const onClickDeactivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: false,
      };
      const saved = await patchJornadaDetalle(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const onClickActivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: true,
      };
      const saved = await patchJornadaDetalle(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _jornadadetalle = await getJornadaDetalle(match.id);
    if (_jornadadetalle?.estados_globales === ESTATUS_ACTIVO
      || _jornadadetalle?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
        || estado?.id === ESTATUS_ACTIVO));
    }
    if (_jornadadetalle?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_jornadadetalle?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    setTimeout(() => {
      if (_jornadadetalle) {
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_jornadadetalle));
          formDatos.setFieldsValue(formatReceived(_jornadadetalle));
          setVisible2(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = !selectedRowKeys.length) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      values.jornada = jornada;
      if (values.fecha_inicial) {
        values.fecha_inicial = values.fecha_inicial?.format('YYYY-MM-DD');
        values.fecha_final = values.fecha_final?.format('YYYY-MM-DD');
      }
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchJornadaDetalle(key, values) : postJornadaDetalle(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteJornadaDetalle(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible2(true);
    // hideParentForm();
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar La jornada ya autorizada');
        return;
      }
      const saved = await autorizarJornadaDetalle(key);
      if (saved) {
        const _data = await getJornadasDetalle();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 100,
    },

    {
      titleText: 'Descripción',
      dataIndex: 'descripcion_rango_horario',
      key: 'descripcion_rango_horario',

      width: 300,
    },
    {
      titleText: 'Lunes',
      dataIndex: 'descripcion_lunes',
      key: 'descripcion_lunes',

      width: 150,
    },
    {
      titleText: 'Martes',
      dataIndex: 'descripcion_martes',
      key: 'descripcion_martes',

      width: 150,
    },
    {
      titleText: 'Miercoles',
      dataIndex: 'descripcion_miercoles',
      key: 'descripcion_miercoles',

      width: 150,
    },
    {
      titleText: 'Jueves',
      dataIndex: 'descripcion_jueves',
      key: 'descripcion_jueves',

      width: 150,
    },
    {
      titleText: 'Viernes',
      dataIndex: 'descripcion_viernes',
      key: 'descripcion_viernes',

      width: 150,
    },
    {
      titleText: 'Sabado',
      dataIndex: 'descripcion_sabado',
      key: 'descripcion_sabado',

      width: 150,
    },
    {
      titleText: 'Domingo',
      dataIndex: 'descripcion_domingo',
      key: 'descripcion_domingo',

      width: 150,
    },
    {
      titleText: 'Total De Horas',
      dataIndex: 'descripcion_total_horas',
      key: 'descripcion_total_horas',

      width: 150,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipos_de_empleado',
      key: 'tipos_de_empleado',
      render: (val) => (Array.isArray(val)
        ? val.map((id) => tiposempleados.find((e) => e.id === id)?.descripcion || 'No encontrada').join(', ')
        : 'No encontrada'),
      width: 150,
    },
    {
      titleText: 'Área',
      dataIndex: 'area_content_id',
      key: 'area_content_id',
      render: (val) => areas.find((e) => e.id === val)?.descripcion,
      width: 150,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      render: (val) => puesto.find((e) => e.id === val)?.descripcion,

      width: 150,
    },

    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const text = 'Jornada que implica entrar a una hora específica de un día y salir a una hora específica del siguiente día.';

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
    horas: [
      requiredRule,
      {
        pattern: integerRegExp,
        validator: async () => {
          const { horas_en_jornada } = form.getFieldsValue();
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(horas_en_jornada)) {
            throw new Error('Ingrese un valor válido');
          }
          if (horas_en_jornada > 24) {
            throw new Error('No se puede exceder el número de horas de un día');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>

        {!open2 ? (
          <Table
            data={data}
            cols={columns}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
              onClickActivate,
              onClickDeactivate,
            }}
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'jornadadetalle', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  // || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
            ]}
            disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Modal
            open={open2}
            width="80%"
            bodyStyle={{ height: '80vh', overflowY: 'auto' }}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Jornada Detalle`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              name="general"
              onFinish={() => onFinish()}
              scrollToFirstError

            >
              <Row gutter={10}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="aplica_vigencia"
                    label="Aplica Vigencia"
                    // rules={rules.concepto}
                    hasFeedback
                  >
                    <Select
                      trueFalse
                    />
                  </Form.Item>
                </Col>
                <Form.Item noStyle shouldUpdate={(prev, curr) => prev.aplica_vigencia !== curr.aplica_vigencia}>
                  {({ getFieldValue }) => getFieldValue('aplica_vigencia') === true && (
                    <>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item
                          name="fecha_inicial"
                          label="Fecha Inicial"
                          rules={rules.required}
                        >
                          <DatePicker placeholder="" format="YYYY-MM-DD" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item
                          name="fecha_final"
                          label="Fecha Final"
                          rules={rules.required}
                        >
                          <DatePicker placeholder="" format="YYYY-MM-DD" />
                        </Form.Item>
                      </Col>
                      {/* <Col xs={24} sm={12} md={8}>
                        <Tooltip placement="top" title={text}>
                          <Form.Item
                            name="horario_compuesto"
                            label="Horario Compuesto"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                            />
                          </Form.Item>
                        </Tooltip>
                      </Col> */}
                    </>
                  )}

                  <Col xs={24} sm={12} md={8}>
                    <Tooltip placement="top" title={text}>
                      <Form.Item
                        name="horario_compuesto"
                        label="Horario Compuesto"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                        />
                      </Form.Item>
                    </Tooltip>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="total_horas_jornada"
                      label="Total de Horas de la Jornada"
                      rules={[
                        rules.required[0],
                        { pattern: integerRegExp, message: 'Debe ser un número entero' },
                      ]}
                      hasFeedback
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                      />
                    </Form.Item>
                  </Col>
                </Form.Item>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="clave"
                    label="Clave"
                    hasFeedback
                    rules={rules.required}
                  >
                    <Input
                      allowClear
                      autoSize={{ minRows: 2, maxRows: 3 }}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="descripcion_rango_horario"
                    label="Descripción"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion_rango_horario"
                      keyProp="id"
                      dataSource={data}
                      allowClear
                      placeholder="Seleccione un Tipo"
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="tipos_de_empleado"
                    label="Tipo de Empleado"
                    // rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      mode="multiple"
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={tiposempleados}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="area_content_id"
                    label="Área"
                    rules={rules.empleado}
                    hasFeedback
                  >
                    <Select
                      labelProp="clave_y_nombre"
                      keyProp="id"
                      dataSource={areas}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="puesto"
                    label="Puesto"
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={puesto}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.required}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estadosFiltered}
                      disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setConfirmationVisibleEstatus(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>

                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>

            </Form>
            <JornadaDetalleHorario
              JornadaDetalle={selectedRowKeys[0]}
              aplicaVigencia={form.getFieldValue('aplica_vigencia')}
              permission={getModelPermission('jornadadetallehorario')}
            />
          </Modal>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Borrar la Jornada Detalle ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar la Jornada Detalle ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default JornadaDetalle;
